import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-charcoal py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Photo */}
          <div className="w-full lg:w-[40%] flex-shrink-0">
            <div className="relative rounded-3xl overflow-hidden max-w-sm mx-auto lg:max-w-none">
              <img
                src="https://static.readdy.ai/image/ca60b0043e5ac75b0711db9039bc28de/916ac9d323bd869a59918b36c30dfb51.webp"
                alt="Jenny – Deine Expertin bei Flow & Glow Köln"
                className="w-full h-[420px] md:h-[520px] object-cover object-top"
              />
              {/* Floating card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-5 py-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-rose/20 rounded-full">
                    <i className="ri-award-line text-rose text-lg" />
                  </div>
                  <div>
                    <p className="font-sans text-xs text-white/60 leading-none mb-0.5">Zertifizierte Expertin</p>
                    <p className="font-sans text-sm font-semibold text-white leading-none">ZMP · 19 Jahre Erfahrung</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-[60%]">
            <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
              Über mich
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-medium text-white mt-3 mb-6 leading-tight">
              Deine Expertin: Jenny
            </h2>
            <p className="font-sans text-base text-white/70 leading-[1.85] mb-6">
              Mit 19 Jahren Erfahrung in der Dentalbranche weiß ich, worauf es ankommt. Bei Flow &amp; Glow bekommst du keine Standard-Anwendung vom Quereinsteiger — du bekommst echte Fachkompetenz, in einer Atmosphäre, in der du dich wohlfühlst.
            </p>

            {/* Handwritten signature */}
            <p
              className="text-2xl mb-10"
              style={{ fontFamily: '\'Dancing Script\', cursive', color: '#d4a08a' }}
            >
              — Jenny
            </p>

            {/* Trust points — dezente Linie statt Icon-Kreise */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
              {[
                { icon: 'ri-medal-line', label: 'Zahnmedizinische Prophylaxe-Assistentin (ZMP)' },
                { icon: 'ri-leaf-line', label: 'PAP-Technologie – peroxidfrei & EU-konform' },
                { icon: 'ri-group-line', label: 'Über 100+ zufriedene Gäste in Köln' },
                { icon: 'ri-drop-line', label: 'Nur geprüfte & hautverträgliche Produkte' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className={`${item.icon} text-rose/70 text-sm`} />
                  </span>
                  <span className="font-sans text-sm text-white/55 leading-snug">{item.label}</span>
                </div>
              ))}
            </div>

            <Link
              to="/ueber-mich"
              className="inline-flex items-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Meine Geschichte lesen
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
